/* unplugin-vue-components disabled */import script from "./ApplicationRecordCard.vue?vue&type=script&setup=true&lang=js"
export * from "./ApplicationRecordCard.vue?vue&type=script&setup=true&lang=js"

import "./ApplicationRecordCard.vue?vue&type=style&index=0&id=5b65652b&scoped=true&lang=less"

import exportComponent from "/Users/zhangxuan/Documents/Projects/VinesDjango/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b65652b"]])

export default __exports__